import type { FC } from "react";
import type { DefaultPeriod } from "../../../../components/features/AiAssistantTemplateForm/validationSchema";
import { PRESET_PERIOD_LABELS, PRESET_PERIODS } from "../periodConverter";
import styles from "./styles.scss";

type Props = {
  onSelect: (preset: DefaultPeriod) => void;
};

export const PresetList: FC<Props> = ({ onSelect }) => {
  return (
    <ul className={styles.presetList}>
      {PRESET_PERIODS.map((preset) => (
        <li key={preset}>
          <button
            type="button"
            className={styles.presetItem}
            onClick={() => onSelect(preset)}
          >
            {PRESET_PERIOD_LABELS[preset]}
          </button>
        </li>
      ))}
    </ul>
  );
};
